import { Box, Flex, HStack, Progress, Text } from "@chakra-ui/react";
import { CaretDown } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../config";
import { colors } from "../../../../theme/foundations/colors";

const STAGE_PROGRESS = {
  START: 10,
  AI_QUEUE: 15,
  EXPERT_REVIEW: 25,
  PENDING: 10,
  IN_PROGRESS: 50,
  INTERNAL_REVIEW: 70,
  AUDIT: 85,
  COMPLETE: 100,
};

const getProgressColor = (stageType) => {
  if (stageType === "COMPLETE" || stageType === "AUDIT") return colors.stages.COMPLETE;
  if (stageType === "IN_PROGRESS" || stageType === "INTERNAL_REVIEW") return colors.stages.IN_PROGRESS;
  return "#E53E3E";
};

const OtherYearCards = ({ currentQuestion, allQuestions }) => {
  const navigate = useNavigate();

  const siblings = (allQuestions || [])
    .filter((q) => q.questionGroup === currentQuestion.questionGroup && q.id !== currentQuestion.id)
    .sort((a, b) => (b.question || "").localeCompare(a.question || ""));

  if (siblings.length === 0) return null;

  return (
    <Flex direction="column" gap={3}>
      {siblings.map((q) => {
        const progress = STAGE_PROGRESS[q.stageType] ?? 10;
        const progressColor = getProgressColor(q.stageType);

        return (
          <Box
            key={q.id}
            borderWidth="1px"
            borderColor="gray.200"
            borderRadius="xl"
            p={5}
            bg="white"
            cursor="pointer"
            _hover={{ borderColor: "gray.300", shadow: "sm" }}
            onClick={() => navigate(`${routes.foundationAnswerDetail}?id=${q.id}`)}
          >
            <Flex justify="space-between" align="flex-start">
              <Box flex="1">
                <Text fontSize="md" fontWeight="bold" color="gray.800">
                  {q.question}
                </Text>
                {q.description && (
                  <Text fontSize="sm" color="gray.500" mt={1} noOfLines={2}>
                    {q.description}
                  </Text>
                )}
              </Box>
              <Box color="gray.400" flexShrink={0} ml={4}>
                <CaretDown size={20} />
              </Box>
            </Flex>

            <HStack spacing={3} mt={3}>
              <Text fontSize="xs" fontWeight="medium" color="gray.600">
                {q.stage}
              </Text>
              {q.stageType !== "COMPLETE" && (
                <Text fontSize="xs" color="gray.400">
                  Draft
                </Text>
              )}
            </HStack>
            <Progress
              value={progress}
              size="xs"
              borderRadius="full"
              bg="gray.100"
              mt={2}
              sx={{ "& > div": { backgroundColor: progressColor } }}
            />
          </Box>
        );
      })}
    </Flex>
  );
};

export default OtherYearCards;
